import { createEpicMiddleware } from "redux-observable";
import { firebaseApp } from "../firebase.config";
import { ajax } from "rxjs/ajax";

export const epicMiddleware = createEpicMiddleware({
  dependencies: { fbApp: firebaseApp, ajax: ajax, window }
});
